<div class="mb-3" [class.has-error]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id" [innerHTML]="props.label"></label>
  <div>
    <form [formGroup]="formLink">
      <div class="form-control-group">
        <div class="me-2">
          <label *ngIf="props.label && props.hideLabel !== true" for="linkHeader" i18n="@@LinkHeaderLabel">Имя ссылки</label>
          <input nbInput
                 id="linkHeader"
                 fieldSize="small"
                 placeholder="Имя ссылки: Разработка b2b платформ"
                 i18n-placeholder="@@LinkHeaderPlaceholder"
                 formControlName="header"
          />
        </div>

        <div class="me-2">
          <label *ngIf="props.label && props.hideLabel !== true" for="linkUrl" i18n="@@LinkUrlLabel">Адрес ссылки</label>
          <input id="linkUrl"
                 nbInput
                 fieldSize="small"
                 placeholder="Ссылка: https://www.compo.ru/"
                 i18n-placeholder="@@LinkUrlPlaceholder"
                 formControlName="url"
          />
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
